module.exports = __webpack_public_path__ + "static/media/Team 10 - TechnoPack.a1147726.jpeg";